module.exports = __webpack_public_path__ + "img/terroir-spiral-2-mobile.6fb1a3a2.jpg";